<template>
  <div>
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h3">예약작업</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{scheduleReloadTime}}</em></span>
        <el-button size="small" @click="exportScheduleInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="dataList" :columns="schedulingColumns" :column-default="columnDefault" :pagination="true" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
    </el-table-wrapper>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import serverInfoAPI from '@/api/config/server/server-info';

export default {
  name: 'WSchedulingInfoNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      showSearchTool: false,
      dataList: null,
      nodeParam: {},
      scheduleReloadTime: '-',
      columnDefault,
      schedulingColumns: [{
        prop: 'NAME',
        label: '작업명',
        width: 300,
        sortable: true,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      {
        prop: 'STATUS',
        label: '상태',
        width: 100,
        sortable: true,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      {
        prop: 'TRIGGER',
        label: '트리거',
        sortable: true,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      {
        prop: 'NEXTEXEDATE',
        label: '다음 실행 시각',
        sortable: true,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      {
        prop: 'LASTEXEDATE',
        label: '마지막 실행 시간',
        sortable: true,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      {
        prop: 'LASTEXEDATERESULT',
        label: '최근 실행 결과',
        sortable: true,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      {
        prop: 'CREATOR',
        label: '생성자',
        sortable: true,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.nodeParam = Object.assign({}, this.nodeParams);
        this.loadStore();
      },
    },
    nodeParams: {
      handler() {
        this.nodeParam = Object.assign({}, this.nodeParams);
        this.loadStore();
      },
      immediate: true,
    },
  },
  methods: {
    loadStore() {
      const me = this;
      if (!isNil(this.nodeParam) && this.activeTab === this.$options.name) {
        const scheduleObj = {
          objId: me.nodeParam.objId,
          ciInstanceId: me.nodeParam.ciInstanceId,
          ipaddressApplytype: me.nodeParam.ipaddressApplytype,
        };
        if (!isNil(me.nodeParam.ipaddressIpv4)) {
          scheduleObj.ipaddressIpv4 = me.nodeParam.ipaddressIpv4;
        }
        if (!isNil(me.nodeParam.ipaddressIpv6)) {
          scheduleObj.ipaddressIpv6 = me.nodeParam.ipaddressIpv6;
        }
        serverInfoAPI.getSchedulingList(scheduleObj).then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            this.dataList = JSON.parse(response.data.data);
            this.scheduleReloadTime = getDateToString(new Date().getTime());
          } else {
            this.scheduleReloadTime = '-';
          }
        });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    exportScheduleInfo() {
      const me = this;
      if (!isNil(me.nodeParam)) {
        const osObj = {
          objId: me.nodeParam.objId,
          ciInstanceId: me.nodeParam.ciInstanceId,
          ipaddressApplytype: me.nodeParam.ipaddressApplytype,
        };
        if (!isNil(me.nodeParam.ipaddressIpv4)) {
          osObj.ipaddressIpv4 = me.nodeParam.ipaddressIpv4;
        }
        if (!isNil(me.nodeParam.ipaddressIpv6)) {
          osObj.ipaddressIpv6 = me.nodeParam.ipaddressIpv6;
        }
        serverInfoAPI.exportSchedulingInfoList(osObj);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/server/scheduling/index.vue